// https://qiita.com/shogo82148/items/548a6c9904eb19269f8c
export const getLocale = () => (window.navigator.languages && window.navigator.languages[0])
    || window.navigator.language
    || window.navigator.userLanguage
    || window.navigator.browserLanguage;
